export enum TicketUseDirection {
  Exit = 'Exit',
  Entry = 'Entry',
}
